export default {
  cachedFetch: {},
};
